export default __webpack_public_path__ + "static/media/PO0131005_WF_BRAND_2HFY24_ISF_JulyUpdate_InfoGraphic_LP_927x521.d77a3611.jpg";